import cxs from 'cxs/component'


export const getVal= (props, variables, defaultVal)  => {
    for(var i = 0; i < variables.length; i++){
        if(variables[i] in props){
            return props[variables[i]]
        }
    }

    return defaultVal
}

export const getValFromTheme = (props, variables, themeProps, defaultVal) => {
        let value;
        for(var i = 0; i < variables.length; i++){
            if(variables[i] in props){
                value = props[variables[i]]
                if(themeProps[value]){
                    return themeProps[value]
                }else if(value){
                    return value
                }
            }
        }
        return defaultVal
}
const filterUndefined = propsStyle => {
    for(var key in propsStyle){
        if(propsStyle[key] === undefined){
            delete propsStyle[key]
        }
    }
    return propsStyle
}

function getHoverColor(props){
    if(props.disabled){
        return props.theme.colors.lightgrey
    }
    return getValFromTheme(props, ['hover'], props.theme.colors)
}

export default function styledComponent(Component, customization=()=>{}) {
  return cxs(Component)(props => (filterUndefined({
      backgroundColor: getValFromTheme(props, ['bg', 'backgroundColor', 'inherit'], props.theme.colors),
      backgroundImage: getVal(props, ['bgImg', 'backgroundImage']),

      color: getValFromTheme(props, ['color', 'inherit'], props.theme.colors),

      height: getVal(props, ['h', 'height']),
      width: getVal(props, ['w', 'width']),
      maxWidth: getVal(props, ['maxw', 'maxWidth']),
      maxHeight: getVal(props, ['maxh', 'maxHeight']),
      minWidth: getVal(props, ['minw', 'minWidth']),
      minHeight: getVal(props, ['minh', 'minHeight']),

      background: getVal(props, ['background']),
      border: getVal(props, ['b', 'border']), //TODO border keyword is not working
      borderTop: getVal(props, ['bt', 'borderTop']),
      borderBottom: getVal(props, ['bb', 'borderBottom']),
      borderLeft: getVal(props, ['bl', 'borderLeft']),
      borderRight: getVal(props, ['br', 'borderRight']),
      borderRadius: getVal(props, ['borderRadius']),
      borderWidth: getVal(props, ['borderWidth']),
      borderColor: getValFromTheme(props, ['borderColor'], props.theme.colors),

      display: getVal(props, ['display']),

      overflow: getVal(props, ['overflow']),
      overflowY: getVal(props, ['overflowY']),
      overflowX: getVal(props, ['overflowX']),
      overflowWrap: getVal(props, ['overflowWrap']),

      zIndex: getVal(props, ['z', 'zIndex']),

      top: getVal(props, ['top']),
      bottom: getVal(props, ['bottom']),
      left: getVal(props, ['left']),
      right: getVal(props, ['right']),

      margin: getVal(props, ['margin']),
      marginTop:    getVal(props, ['marginTop', 'my', 'mt']),
      marginBottom: getVal(props, ['mb', 'marginBottom', 'my']),
      marginLeft:   getVal(props, ['marginLeft', 'ml', 'mx']),
      marginRight:  getVal(props, ['mr', 'marginRight', 'mx']),

      padding: getVal(props, ['padding']),
      paddingTop:   getVal(props, ['pt', 'paddingTop', 'py']),
      paddingBottom: getVal(props, ['pb', 'paddingBottom', 'py']),
      paddingLeft:  getVal(props, ['pl', 'paddingLeft', 'px']),
      paddingRight: getVal(props, ['pr', 'paddingRight', 'px']),

      position: getVal(props, ['pos', 'position']),

      opacity: getVal(props, ['opacity']),
      transition: getVal(props, ['transition']),
      transitionDelay: getVal(props, ['transitionDelay']),
      transform: getVal(props, ['transform']),
      visibility: getVal(props, ['visibility']),
      filter: getVal(props, ['filter']),

      fontSize: getVal(props, ['fontSize']),
      fontWeight: getVal(props, ['fontWeight']),
      textAlign: getVal(props, ['textAlign']),
      lineHeight: getVal(props, ['lineHeight']),
      textDecoration: getVal(props, ['textDecoration']),

      whiteSpace: getVal(props, ['whiteSpace']),
      wordBreak: getVal(props, ['wordBreak']),

      cursor: getVal(props, ['cursor']),
      hyphens: getVal(props, ['hyphens']),
      userSelect: getVal(props, ['userSelect']),
      boxShadow: getVal(props, ['boxShadow']),

      ':hover': {
          color: getHoverColor(props),
          backgroundColor: getValFromTheme(props, ['backgroundHover'], props.theme.colors),
          border: getVal(props, ['hoverBorder']),
          opacity: getVal(props, ['hoverOpacity'])
      },
      ...customization(props)
  })
  ))
}



// WEBPACK FOOTER //
// ./src/hoc/styledComponent.js